export const MAX_TIMEZONE_OFFSET = 14;
export const MIN_TIMEZONE_OFFSET = -12;
//# sourceMappingURL=constants.js.map